export const resources = {
  Files: '',
  IndexingFileNameEmptyMessage: '',
  IndexingFileNameLinkEmptyText: ''
};
